import React from 'react';
import {
  flipPanelWidth,
  fontFamily,
  imageBasePath,
  navigationTabContentStretchedWrapperHeight,
  isRtl,
  isDevelopment,
  activeNoticeBannerHeight
} from '../../../library/constants';
import {
  isAndroidTablet,
  isMobilePhone,
  doesExpiringUpsellExist,
  // doWhenReady,
} from '../../../library/calc';
import styled from 'styled-components';
import Icons from './Icons';
import Menubar from './Menubar';
import { Description } from './Description';
import More from './More';
import Whoinfo from '../Whoinfo';
import Avatar from '../Avatar';

const iconsContainerWidth = 330;
const iconBoxSide = 82.5;

class Flippanel extends React.Component {

  moreMenuVisibile = false;

  constructor(props){
    super(props);
    this.state = {
      moreListShow: false,
      fetchIsLoading: true,
    }
  }

  componentDidMount(){

    window.forceHideMoreList = this.forceHideMoreList.bind(this);
    this.setState({
      fetchIsLoading: true,
      moreListShow: false,
    })
    window.callFlipPanelComponentUpdate = this.flippanelShouldUpdate.bind(this);
  }

  dataIsLoaded(){
    return typeof(this.props.nodeForFlipFocus) !== 'undefined' &&
        this.props.nodeForFlipFocus &&
        typeof(this.props.nodeObjs[this.props.nodeForFlipFocus]) !== 'undefined'
  }

  componentDidUpdate (prevProps, prevState, snapshot){

    if(isDevelopment)  return;

    // console.count('Flippanel/componentDidUpdate')
    // console.log(`typeof(this.props.nodeForFlipFocus): `, typeof(this.props.nodeForFlipFocus));
    // console.log(`this.props.nodeForFlipFocus: `, this.props.nodeForFlipFocus);
    // if(this.props.nodeForFlipFocus) console.log(`typeof(this.props.nodeObjs[this.props.nodeForFlipFocus]): `,this.props.nodeObjs[this.props.nodeForFlipFocus]);
    // console.log(`this.dataIsLoaded(): `, this.dataIsLoaded());

    if( this.dataIsLoaded() ){

      const nodeForFlipFocus = this.props.nodeForFlipFocus;
      const flipData = this.props.nodeObjs[nodeForFlipFocus].flipData;

      if( !this.state.fetchIsLoading &&
          typeof(flipData) === 'undefined'
      ){
        // console.log('turning on spinner');
        this.setState({
          fetchIsLoading: true,
          moreListShow: false,
        })
      }

      if( this.state.fetchIsLoading &&
          typeof(flipData) !== 'undefined'
      ){
        this.setState({
          fetchIsLoading: false,
        });
        setTimeout(() => {
          this.flippanelShouldUpdate({once: true, fromWhere: 'A'});
        }, 800);
      }

    } else{

        // console.log('turning on spinner');
        this.setState({
          fetchIsLoading: true,
          moreListShow: false,
        })
    }

  }

  forceUpdateIntervalcount = 0;
  flippanelShouldUpdate({once, fromWhere}){

    if( typeof(fromWhere) !== 'undefined'  ){
      // console.log('flippanelShouldUpdate:', fromWhere);
      // console.log(`once: `, once);
    }

    if( typeof(once) !== 'undefined' && once === true){
      // console.log(`typeof(once): `, typeof(once));
      // console.log(`once: `, once);
      // console.log('forceUpdate Once');
      this.forceUpdate();
      return;
    }

    // console.log('more than once:', fromWhere);

    // console.log('Flippanel/forceUpdate');

    // console.log(' ');
    // console.log('========================');
    clearInterval(this.forceUpdateInterval);
    this.forceUpdateInterval = setInterval(()=>{
      this.forceUpdateIntervalcount++;
      this.forceUpdate();
      // console.log(' ');
      // console.log(`forceUpdateIntervalcount: `, this.forceUpdateIntervalcount);
      if(this.forceUpdateIntervalcount >= 2 ) {
        clearInterval(this.forceUpdateInterval);
        this.forceUpdate();
        this.forceUpdateIntervalcount = 0
      }
    }, 800);

/*
    const dataIsLoaded = () => {
      this.forceUpdate();
      return this.dataIsLoaded();
    }

    const callback = () => {
      console.log('dataIsLoaded for ', this.props.nodeObjs[this.props.nodeForFlipFocus].nm);
    }

    doWhenReady({argument: '', condition: dataIsLoaded, callback, attempts: {ongoing:0, end: 99999999}, fromWhere: 'Flippanel'})
*/

  }

  shouldUpdate = true;
  shouldComponentUpdate(nextProps, nextState) {
    // return this.shouldUpdate;
    if(isDevelopment) return true;
    return false;
  }

  allowComponentUpdate(bool){
    if(typeof(bool) === 'undefined' ){
      this.shouldUpdate = ( this.shouldUpdate === false ? true: false)
    } else {
      this.shouldUpdate = bool;
    }
  }

  toggleMoreList(){
    this.moreMenuVisibile = true;
    const moreListShow =  ( isAndroidTablet() ? true: !this.state.moreListShow)
    this.setState({ moreListShow });
    const once = true;
    this.flippanelShouldUpdate({once});
  }

  UNSAFE_componentWillReceiveProps(props){
    // this.hideMoreList();
  }

  hideMoreList(){
    if(!this.moreMenuVisibile){
      this.setState({
        moreListShow: false,
      })
      this.moreMenuVisibile = false;
    }
  }

  forceHideMoreList(){
    // console.count('...forceHideMoreList');
    this.setState({
      moreListShow: false,
    })
    this.moreMenuVisibile = false;
  }

  showProgressIndicator(){
    if( this.state.fetchIsLoading ) {
      return  <div style={{
                width: '100%',
                height: '75%',
                position: 'absolute',
              }}>
                <img
                  id="progressIndicator"
                  alt=""
                  src={imageBasePath + 'loading.gif' }
                  style={{
                    width: `${50}px`,
                    height: `${50}px`,
                    position: 'absolute',
                    top: '45%',
                    bottom: '0',
                    left: '0',
                    right: '0',
                    margin: 'auto',
                }}/>
              </div>
    } else {
      return null
    }

  }

  resizePhotoUploadModalForDesktopAndTablets(){

    if(isRtl) {

      const thinBorderLightbox = document.getElementById("thin-border-lightbox")
      thinBorderLightbox.classList.add("rtl")
      thinBorderLightbox.style.setProperty("text-align", "right", "important");

    }

    if(isAndroidTablet() ){

      setTimeout(() => {
        const thinBorderLightbox = document.getElementById("thin-border-lightbox")
        thinBorderLightbox.style.setProperty("top", "initial", "important");
        thinBorderLightbox.style.setProperty("bottom", "0px", "important");
        const cancel = document.querySelector('#cancel-upload-button');
        cancel.style.setProperty("top", "55px", "important");
        const album_media = document.querySelector('.album_media');
        album_media.style.setProperty("height", "275px", "important");
        const accordion = document.querySelector('#accordion');
        accordion.style.setProperty("height", "249px", "important");
      }, 600);

      return;
    }

    if( !isMobilePhone() ){

      setTimeout(() => {
        const thinBorderLightboxHeight = 480;
        const thinBorderLightbox = document.getElementById("thin-border-lightbox")
        const topMargin =  (this.props.canvasHeight - thinBorderLightboxHeight) / 2;
        const topString = `${topMargin}px`;
        thinBorderLightbox.style.setProperty("top", topString, "important");
      }, 600);
      return;

    }
  }

  moreMenuIsPartiallyVisible({moreMenuTrueHeight, moreMenuVisibleHeight}){
    return moreMenuVisibleHeight < moreMenuTrueHeight;
  }

  render () {

    let transform = null;

    if(this.props.flipPanelOpened /*|| isDevelopment*/){
      transform = `translateX(0px)`;
    } else {
      transform = `translateX(${-1*flipPanelWidth}px)`;
    }

    const { navigationPanelIsUp } = this.props;

    let flippanelStyle = {
      position: 'absolute',
      width: `${flipPanelWidth}px`,
      background: 'white',
      height: `${(this.props.canvasHeight -  ( navigationPanelIsUp ? (navigationTabContentStretchedWrapperHeight - 2) : 1 ))}px`,
      transform,
      boxShadow: `3px 0 7px rgba(150,150,150,0.5)`,
      fontFamily: `${fontFamily}`,
      left: '0px'
    }

    if( isAndroidTablet()){
      flippanelStyle = {...flippanelStyle,
        overflowY: 'scroll'
      }
    }

    if( this.props.chartType === 'fan'){
      flippanelStyle = {...flippanelStyle,
        height: `${ this.props.canvasHeight + 2}px`,
      }

      if( doesExpiringUpsellExist){

        flippanelStyle = {...flippanelStyle,
          top: `${ 55 }px`,
        }
      }
    }

    const MainBody = styled.div`
      padding: 20px;
      height: 108px;
    `;

    const moreMenuTrueHeight = 186;
    const moreMenuVisibleHeight = this.props.canvasHeight - 300;

    // console.count('Flippanel/render');

    return (
      <div
        id="flip-panel"
        style={flippanelStyle}
        onMouseEnter={()=>{
          this.props.setMouseOverBoxDisplay('mouseOverLeftBox', false);
        }}
      >
        {this.showProgressIndicator()}
        <Menubar {...this.props} flippanelShouldUpdate={this.flippanelShouldUpdate.bind(this)}/>
        <MainBody>
          <div style={{ height: '100%'}}>

            <Avatar {...this.props} fetchIsLoading={this.state.fetchIsLoading} resizePhotoUploadModalForDesktopAndTablets={this.resizePhotoUploadModalForDesktopAndTablets.bind(this)}/>
            <Whoinfo {...this.props} fetchIsLoading={this.state.fetchIsLoading}/>

          </div>

          <Icons
            {...this.props}
            resizePhotoUploadModalForDesktopAndTablets={this.resizePhotoUploadModalForDesktopAndTablets.bind(this)}
            fetchIsLoading={this.state.fetchIsLoading}
            showHookMessageForNearbyTreeMatches={this.props.showHookMessageForNearbyTreeMatches}
            toggleMoreList={this.toggleMoreList.bind(this)}
            hideMoreList={this.hideMoreList.bind(this)}
            iconsContainerWidth={iconsContainerWidth}
            iconBoxSide={iconBoxSide}
            hideProductTour={this.props.hideProductTour}
            chartType={this.props.chartType}
          />

          <Description
            {...this.props}
            nodeForFlipFocus={this.props.nodeForFlipFocus}
            nodeObjs={this.props.nodeObjs}
            chartType={this.props.chartType}
            fetchResolveAndPopModal={this.props.fetchResolveAndPopModal}
            iconsContainerWidth={iconsContainerWidth}
            fetchIsLoading={this.state.fetchIsLoading}
          />

          <div style={{
                  display: (this.state.moreListShow  ? 'block': 'none' ),
                  // background: 'red',
                  position: 'absolute',
                  right: '18px',
                  top: '293px',
                  width: '165.5px',
                  height: `${ this.moreMenuIsPartiallyVisible({moreMenuTrueHeight, moreMenuVisibleHeight}) ? moreMenuVisibleHeight: moreMenuTrueHeight}px`,
                  overflow: `${ this.moreMenuIsPartiallyVisible({moreMenuTrueHeight, moreMenuVisibleHeight}) ? 'scroll' : 'initial'}`,
                }}

                onMouseEnter={()=>{
                  this.moreMenuVisibile = true;
                }}
                onMouseLeave={()=>{
                  this.moreMenuVisibile = true;
                }}
          >
            { this.state.moreListShow ?  <More {...this.props} resizePhotoUploadModalForDesktopAndTablets={this.resizePhotoUploadModalForDesktopAndTablets.bind(this)}/>  :  null  }
          </div>
        </MainBody>
      </div>
    );
  }
}

export default Flippanel;
